import { render, staticRenderFns } from "./TailWizard.vue?vue&type=template&id=3dd0a168&scoped=true"
import script from "./TailWizard.vue?vue&type=script&lang=js"
export * from "./TailWizard.vue?vue&type=script&lang=js"
import style0 from "./TailWizard.vue?vue&type=style&index=0&id=3dd0a168&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd0a168",
  null
  
)

export default component.exports